import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { BsThreeDotsVertical } from "react-icons/bs";
import './Add_Complaint.css';
import { MdDelete } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import axios from "axios";
import { FiX, FiUpload } from "react-icons/fi"; // Close & Upload icons
import moment from 'moment';
import MessageBox from '../MessageBox/MessageBox';


export default function Verification_Complaint({ selectedFile,
  setSelectedFile, complaintDetails, setComplaintDetails, isSubmitting, handleSubmit }) {


  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const locate = useLocation();


  const [isOpenThreeDots, setIsOpenThreeDots] = useState(false);

  // const[verificationDetails,setverificationDetails]=useState({})



  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  useEffect(() => {
    axios
      .post(apiUrl + "get-complaint", {
        id: locate.state?.id,
      })
      .then((res) => {
        if (res.data?.message) {
          const data = JSON.parse(JSON.stringify(res.data.message)); // Deep clone to avoid freeze/memo issues
          setComplaintDetails(data);
        }
      });
  }, [locate.state?.id]);


  const createdDate = complaintDetails.createdDate; // ISO string from backend
  const daysAgo = moment().diff(moment(createdDate), 'days');

  const formatDatecreate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;


    console.log(name,value)

    setComplaintDetails((prev) => ({
      ...prev,
      verification: {
        ...prev.verification,
        [name]: value,
      },
    }));
  };



  return (
    <div>
      <Container>

        <form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(complaintDetails); // Trigger parent submit handler
        }}>

          <div className='plan-details-container-border-complaint mt-5 text-center ms-5'>
            <p style={{ fontSize: "13px" }} className='mt-3'>
              {/* <span className='text-primary'>Network</span> */}
              Complaint - <span className='text-primary'>{complaintDetails?.complaintType}</span> Customer Affected - <span className='text-primary'>{complaintDetails?.complaintcustomerAffected} @ </span>Location - <span className='text-primary'>{complaintDetails?.complaintlocation}</span></p>
            <p style={{ fontSize: "13px" }} class="mb-3"
            > Complaint Open Date - <span className='text-primary'>{formatDatecreate(complaintDetails?.createdDate)} , </span> Complaint Open Last - <span className='text-primary'>{daysAgo} Days</span></p>
          </div>






          <div className="modal1-verification-converted mt-5 ">
            <Container>

              <Row className='text-start'>
                <Col>
                  <label>Verification Status</label>
                  <br></br>
                  <select className='form-input-select'
                    onChange={handleChange}
                    value={complaintDetails.verification?.verificationStatus || ""}
                    name='verificationStatus'
                      disabled={complaintDetails?.verification?.isCompleted === true}

                  >
                    <option value="Open">Open</option>
                    <option value="Verified">Verified</option>

                    <option value="Not Available">Not Available</option>


                  </select>
                </Col>
                <Col>
                  <Col className="date-update-textbox">
                    <label>Next Follow Up Date</label>
                    <br />
                    <input
                      type="date"
                      className="field form-input"
                      onChange={handleChange}
                        disabled={complaintDetails?.verification?.isCompleted === true}

                      name="nextFollowUpDate" // Ensure this matches the key in your state
                      value={complaintDetails.verification?.nextFollowUpDate || ""}
                    />

                  </Col>
                </Col>
              </Row>

              <textarea
                style={{
                  textTransform: "capitalize",
                  resize: "none",
                }}
                placeholder="Enter Notes"
                className="converted-textbox"
                onChange={handleChange}
                value={complaintDetails.verification?.notes || ""}
                name="notes"
                  disabled={complaintDetails?.verification?.isCompleted === true}


              />
              <div className="upload-section">
                <label className="upload-btn">
                  <FiUpload className="upload-icon" />
                  Upload Image
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}

  disabled={complaintDetails?.verification?.isCompleted === true}

                    hidden
                  />
                </label>
                {selectedFile && (
                  <p className="file-name">{selectedFile.name}</p>
                )}
              </div>


            </Container>
          </div>


          {/* <div className='verification-photo-upload'>




            <Row className='mt-3'>
              <Col md={4} sm={4} className='text-center'>
                <h6>K.Saravanan  <span className='text-secondary ms-4'>2h</span></h6>
              </Col>



              <Col md={4} sm={4} className='text-start' >
                <h5>Installation/Verified</h5>
              </Col>

              <Col md={4} sm={4} className='text-center'>
                <span onClick={() => setIsOpenThreeDots(true)}><BsThreeDotsVertical /></span>

                {isOpenThreeDots && (
                  <div className='threedot-popup'>

                    <div className='text-end cross-symbol-verification'><span onClick={() => setIsOpenThreeDots(false)}><RxCross2 /></span>
                    </div>
                    <Row className='ms-1 mt-1'>
                      <Col md={2} sm={2}>
                        <input type="checkbox" />
                      </Col>
                      <Col md={10} sm={10} className='text-start'>
                        Approved
                      </Col>
                    </Row>
                    <Row className='ms-1 mt-2 mb-2'>
                      <Col md={2} sm={2}>
                        <MdDelete />

                      </Col>
                      <Col md={10} sm={10} className='text-start'>
                        Delete</Col>
                    </Row>
                  </div>
                )}

              </Col>


            </Row>

            <Row className='mt-4'>
              <Col md={2} sm={2}>
                <div className='img-verification-profile ms-4 '>
                  <img src="data:image/jpeg;base64,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" width="50px" height="50px" style={{ borderRadius: "50%" }} />
                </div>
              </Col>
              <Col md={9} sm={9} >

                <p>Still Customer Not Paid, alredy  we gave more times.</p>
              </Col>
            </Row>

            <div className='verificatin-photo-background mt-5 mb-5 '>
              <div className='text-center'>
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuD8LaNCgp4Txe8LigEYq3Wc0k2eX8f033ZtLCWriItZVNEbHTtvc8hNTyJ_nzLCye2Xc&usqp=CAU" width="300px" />
              </div>

            </div>


          </div> */}


        </form>
      </Container>




    </div>
  )
}
